import { seoResolver } from "../../modules/app-route";
import { AppRoutes } from "../../modules/app-route/models/app-route.model";

export const AKTUELL_ROUTES: AppRoutes = [
    {
        path: "",
        loadComponent: () => import('./components/aktuell-carousel/aktuell-carousel.component').then(mod => mod.AktuellCarouselComponent),
        outlet: "carousel"
    },
    {
        path: "",
        loadComponent: () => import('./components/aktuell-home/aktuell-home.component').then(mod => mod.AktuellHomeComponent),
        title: 'YSTM - Aktuelles',
        data: {
            meta: {
                description: 'Aktuelle YSTM-Nachrichten, Termine und Veranstaltungen'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];